/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./global-login.component";
import * as i2 from "@angular/router";
import * as i3 from "../../../services/auth/user.service";
import * as i4 from "@ngrx/store";
var styles_GlobalLoginComponent = [];
var RenderType_GlobalLoginComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_GlobalLoginComponent, data: {} });
export { RenderType_GlobalLoginComponent as RenderType_GlobalLoginComponent };
export function View_GlobalLoginComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_GlobalLoginComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "marlin-global-login", [], null, null, null, View_GlobalLoginComponent_0, RenderType_GlobalLoginComponent)), i0.ɵdid(1, 114688, null, 0, i1.GlobalLoginComponent, [i2.ActivatedRoute, i2.Router, i3.UserService, i4.Store], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var GlobalLoginComponentNgFactory = i0.ɵccf("marlin-global-login", i1.GlobalLoginComponent, View_GlobalLoginComponent_Host_0, {}, {}, []);
export { GlobalLoginComponentNgFactory as GlobalLoginComponentNgFactory };
